import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {EmailDomainsInputContainer} from '../../../../../../../../src/components/common/createFormInputs/emailDomainsInputContainer';
import {DomainModel, DomainValidityStatusesEnum} from '../../../../../../../../src/models/api/domainModel';
import {Trans} from '../../../../../../../shared/helpers/src/internationalization/react';
import {fontSizes, fontWeights} from '../../../../../../../shared/ui/src/styles/fontStyles';
import {CrmSyncsFormModel} from './crmSyncsForm';
import {CrmSyncCardDefaultFieldTypesEnum} from './crmSyncsPageConfig/crmSyncsPageConfigHelpers';
import {
  StyledSectionHeaderWrapperDiv,
  StyledSectionTitleDiv,
  StyledTitleWrapperDiv,
} from './crmSyncsSectionWrapper';

interface CrmSyncsDomainFilterProps {
  formState: CrmSyncsFormModel;
  isDisabled: boolean;
  onFormChange: (updatedSyncFormModel: CrmSyncsFormModel) => void;
}

interface StyledEmailDomainsInputWrapperDivProps {
  $isDisabled: boolean;
}

const StyledEmailDomainsInputWrapperDiv = styled.div<StyledEmailDomainsInputWrapperDivProps>`
  width: 600px;
  margin-bottom: 10px;
  ${(p) =>
    p.$isDisabled &&
    css`
      opacity: 0.5;
    `}
`;

const StyledDescriptionWrapperDiv = styled.div`
  margin-top: 8px;
  color: ${(p) => p.theme.greys.shade70};
  line-height: 22px;
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.normal};
`;

export const CrmSyncsDomainFilter: FC<CrmSyncsDomainFilterProps> = (props) => {
  const {formState, isDisabled, onFormChange} = props;
  const domainFilters = (formState.filter && formState.filter[CrmSyncCardDefaultFieldTypesEnum.EMAIL]) || [];
  const domains = domainFilters.map((domain) => ({
    name: domain,
    validityStatus: DomainValidityStatusesEnum.VALID,
  }));

  const updateDomains = (domainObjs: ReadonlyArray<DomainModel>) => {
    const emailFilter = {
      [CrmSyncCardDefaultFieldTypesEnum.EMAIL]: domainObjs.map((d) => d.name),
    };
    const filter = {...formState.filter, ...emailFilter};
    onFormChange({...formState, filter});
  };
  return (
    <StyledEmailDomainsInputWrapperDiv $isDisabled={isDisabled}>
      <EmailDomainsInputContainer
        domains={domains}
        updateDomains={updateDomains}
        customHeaderAndDescription={
          <StyledSectionHeaderWrapperDiv>
            <StyledTitleWrapperDiv>
              <StyledSectionTitleDiv>
                <Trans id="crm-syncs-form-domain-filter-title">Choose which domains to sync</Trans>
              </StyledSectionTitleDiv>
            </StyledTitleWrapperDiv>
            {
              <StyledDescriptionWrapperDiv>
                <Trans id="crm-syncs-form-domain-filter-description">
                  Enter the domain(s) you’d like to sync, e.g. frontapp1.com, frontapp2.com. If you leave this
                  empty, we’ll sync all enabled users and groups from your Azure Directory.
                </Trans>
              </StyledDescriptionWrapperDiv>
            }
          </StyledSectionHeaderWrapperDiv>
          //
        }
        customPlaceholder="[optional] add domain(s)"
      />
    </StyledEmailDomainsInputWrapperDiv>
  );
};
